/**
 * LOGIN TYPES STORE
 */

import Vue from "vue";
import api from "Api";
import router from "Router";

const state = {
    login_types: JSON.parse(localStorage.getItem("login_types")) || null,
};

// getters
const getters = {
    login_type_loader: (state) => (id) => {
        alert(id);
        return state.login_type_loader;
    },
    login_types: (state) => {
        return state.login_types;
    },
};

// actions
const actions = {
    async fetchLoginType({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (payload.commit) {
                    commit("mutateTypeOfLogin", {
                        property: payload.stateProperty,
                        with: response.data[payload.dataProperty ? payload.dataProperty : payload.stateProperty],
                    });
                    if (payload.localStorage) {
                        localStorage.setItem(
                            payload.stateProperty,
                            JSON.stringify(response.data[payload.dataProperty ? payload.dataProperty : payload.stateProperty])
                        );
                    }
                }
                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    mutateTypeOfLogin(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
